import React from 'react';
import dayjs from 'dayjs';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { ResponsiveContainer } from 'recharts';

interface ChartProps {
    data: DataPoint[];
    title: string;
    dataKey: keyof DataPoint;
    stroke: string;
    domain: [Date, Date]
}

const Chart: React.FC<ChartProps> = ({ data, title, dataKey, stroke, domain }) => {
    return (
        <div className="chart-container">
            <h2>{title}</h2>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart
                    data={data}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="created_at"
                        type="number"
                        scale="time"
                        domain={domain.map(date => date.getTime()) as [number, number]}
                        tickFormatter={(value) => dayjs(value).format("HH:mm")}
                    />
                    <YAxis />
                    <Tooltip
                        labelFormatter={(label) => dayjs(label).format("YYYY-MM-DD HH:mm:ss")}
                        formatter={(value: number) => [value.toFixed(1), title]}
                    />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey={dataKey}
                        stroke={stroke}
                        name={title}
                        dot={{ strokeWidth: 2 }}
                        strokeWidth={0}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default Chart;